import { render, staticRenderFns } from "./BoardCountry.vue?vue&type=template&id=5e67f688&scoped=true&"
import script from "./BoardCountry.vue?vue&type=script&lang=js&"
export * from "./BoardCountry.vue?vue&type=script&lang=js&"
import style0 from "./BoardCountry.vue?vue&type=style&index=0&id=5e67f688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67f688",
  null
  
)

export default component.exports